<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Aguarde ...</p>
</ngx-spinner>

<!-- Navigation Menu -->


<nav class="navbar navbar-expand-lg fixed-top shadow-sm py-2" style="background-color: rgba(255, 255, 255, 0.95);">
  <div class="container-fluid px-5">
    <a href="#">
      <img src="assets/images/logo.png" alt="E-Cidadanias Logo" height="80">
    </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <button class="btn btn-outline-dark px-3 fw-medium d-lg-none" style="font-size: 0.9rem; border-width: 2px; transition: all 0.3s ease; margin-right: 1rem;" (click)="login()">Login</button>
    <div class="collapse navbar-collapse justify-content-end" id="navbarNav">
      <ul class="navbar-nav align-items-center">
        <!--<li class="nav-item mx-3">
          <a class="nav-link px-3 fw-medium" (click)="navigateToSection('servicos')" style="cursor: pointer; font-size: 1.05rem; transition: color 0.3s ease; color: #333;">Serviços</a>
        </li>
        <li class="nav-item mx-3">
          <a class="nav-link px-3 fw-medium" (click)="navigateToSection('como-funciona')" style="cursor: pointer; font-size: 1.05rem; transition: color 0.3s ease; color: #333;">Como Funciona</a>
        </li>
        <li class="nav-item mx-3">
          <a class="nav-link px-3 fw-medium" (click)="navigateToSection('depoimentos')" style="cursor: pointer; font-size: 1.05rem; transition: color 0.3s ease; color: #333;">Depoimentos</a>
        </li>
        <li class="nav-item mx-3">
          <a class="nav-link px-3 fw-medium" (click)="navigateToSection('contato')" style="cursor: pointer; font-size: 1.05rem; transition: color 0.3s ease; color: #333;">Contato</a>
        </li>-->
        <li class="nav-item ms-3">
          <button class="btn btn-outline-dark px-4 fw-medium" style="font-size: 1.05rem; border-width: 2px; transition: all 0.3s ease;" (click)="login()">Login</button>
        </li>
      </ul>
    </div>
  </div>
</nav>

<style>
.navbar-nav {
  margin-right: 2rem;
}

.nav-link:hover {
  color: #666 !important;
}

.btn-outline-dark:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  background-color: #333;
  color: white;
}

.navbar {
  border-bottom: 1px solid rgba(0,0,0,0.05);
  backdrop-filter: blur(5px);
}

@media (max-width: 991.98px) {
  .navbar-brand {
    margin: 0 auto;
  }
  
  .navbar-toggler {
    position: absolute;
    right: 1rem;
  }
  
  .btn-outline-dark.d-lg-none {
    position: absolute;
    right: 4rem;
    top: 50%;
    transform: translateY(-50%);
  }
}

.btn-primary {
  background-color: #153658;
  border-color: #153658;
  transition: all 0.3s ease;
  position: relative;
  min-width: 200px;
}

.btn-primary:hover {
  background-color: #1a4370;
  border-color: #1a4370;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.btn-primary:disabled {
  background-color: #153658;
  border-color: #153658;
  opacity: 0.8;
  cursor: not-allowed;
}

/* Estilos para o botão de loading */
.spinner-border {
  width: 1rem;
  height: 1rem;
  border-width: 0.15em;
}

/* Animação de fade para o botão */
.btn-primary span {
  transition: opacity 0.3s ease;
}

.btn-primary:disabled span {
  opacity: 0.7;
}
</style>

<div class="coleta-cliente-container">
  <div class="container">
    <h1 class="text-center mb-5">Cadastro de Cliente</h1>
    
    <form [formGroup]="clienteForm" (ngSubmit)="onSubmit()" class="form-container">
      <!-- Dados Básicos -->
      <div class="card mb-4">
        <div class="card-header">
          <h3>Dados Pessoais</h3>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label for="NOME" class="form-label">Nome completo: <span style="color: red">*</span></label>
              <input type="text" class="form-control" id="NOME" formControlName="NOME" required>
            </div>
            <div class="col-md-6 mb-3">
              <label for="email" class="form-label">E-mail: <span style="color: red">*</span></label>
              <input type="email" class="form-control" id="email" formControlName="email" required>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 mb-3">
              <label for="cpf" class="form-label">CPF: <span style="color: red">*</span></label>
              <input type="text" class="form-control" id="cpf" formControlName="cpf" [textMask]="{mask: cpfMask}" required>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 mb-3">
              <label for="pais" class="form-label">País: <span style="color: red">*</span></label>
              <select class="form-control" id="pais" formControlName="pais" required>
                <option value="Brasil">Brasil</option>
                <option value="Itália">Itália</option>
                <option value="Estados Unidos">Estados Unidos</option>
                <option value="Argentina">Argentina</option>
                <option value="Portugal">Portugal</option>
                <option value="Espanha">Espanha</option>
                <option value="França">França</option>
                <option value="Alemanha">Alemanha</option>
                <option value="Reino Unido">Reino Unido</option>
                <option value="Canadá">Canadá</option>
              </select>
            </div>
            <div class="col-md-6 mb-3">
              <label for="telefone" class="form-label">Telefone: <span style="color: red">*</span></label>
              <input type="text" class="form-control" id="telefone" formControlName="telefone" [textMask]="{mask: telefoneMaskAtual}" required>
              <small class="form-text text-muted">Formato: {{ paisSelecionado }}</small>
            </div>
          </div>
          <div class="mb-3">
            <label for="endereco" class="form-label">Endereço completo: <span style="color: red">*</span></label>
            <textarea class="form-control" id="endereco" formControlName="endereco" rows="3" required></textarea>
          </div>
        </div>
      </div>

      <!-- Tipo de Demanda -->
      <div class="card mb-4">
        <div class="card-header">
          <h3>Tipo de Demanda <span style="color: red">*</span></h3>
        </div>
        <div class="card-body">
          <div class="form-check mb-3">
            <input class="form-check-input" type="radio" name="tipoDemanda" id="jureSanguinis" value="jure_sanguinis" formControlName="tipoDemanda">
            <label class="form-check-label" for="jureSanguinis">
              Desejo reconhecer minha cidadania italiana jure sanguinis
            </label>
          </div>
          <div class="form-check mb-3">
            <input class="form-check-input" type="radio" name="tipoDemanda" id="filhoMenor" value="filho_menor" formControlName="tipoDemanda">
            <label class="form-check-label" for="filhoMenor">
              Desejo reconhecer a cidadania italiana de filho/a menor ainda não registrado/a
            </label>
          </div>
          <div class="form-check mb-3">
            <input class="form-check-input" type="radio" name="tipoDemanda" id="outraDemanda" value="outra_demanda" formControlName="tipoDemanda">
            <label class="form-check-label" for="outraDemanda">
              Desejo apresentar outro tipo de demanda, como: cidadania italiana por matrimônio, outras cidadanias, naturalização brasileira, questões migratórias, vistos, consultorias jurídicas e questões jurídicas em geral.
            </label>
          </div>
        </div>
      </div>

      <!-- Relato Inicial -->
      <div class="card mb-4">
        <div class="card-header">
          <h3>Relato Inicial</h3>
        </div>
        <div class="card-body">
          <div class="mb-3">
            <label for="RELATO_INICIAL" class="form-label">Descreva brevemente sua situação ou necessidade:</label>
            <textarea class="form-control" id="RELATO_INICIAL" formControlName="RELATO_INICIAL" rows="4" placeholder="Digite seu relato inicial..."></textarea>
          </div>
        </div>
      </div>

      <!-- Árvore Genealógica (visível apenas para jure sanguinis) -->
      <div class="card mb-4" *ngIf="showArvoreGenealogica">
        <div class="card-header">
          <h3>Árvore Genealógica</h3>
        </div>
        <div class="card-body">
          <div class="mb-4">
            <label class="form-label">Indique seu grau de parentesco com o/a italiano/a:</label>
            <div class="row">
              <div class="col-md-3 mb-2">
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="parentesco" id="filho" value="filho" formControlName="parentesco">
                  <label class="form-check-label" for="filho">Filho/a – 1ª geração</label>
                </div>
              </div>
              <div class="col-md-3 mb-2">
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="parentesco" id="neto" value="neto" formControlName="parentesco">
                  <label class="form-check-label" for="neto">Neto/a – 2ª geração</label>
                </div>
              </div>
              <div class="col-md-3 mb-2">
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="parentesco" id="bisneto" value="bisneto" formControlName="parentesco">
                  <label class="form-check-label" for="bisneto">Bisneto/a – 3ª geração</label>
                </div>
              </div>
              <div class="col-md-3 mb-2">
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="parentesco" id="trineto" value="trineto" formControlName="parentesco">
                  <label class="form-check-label" for="trineto">Trineto/a – 4ª geração</label>
                </div>
              </div>
              <div class="col-md-3 mb-2">
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="parentesco" id="tetraneto" value="tetraneto" formControlName="parentesco">
                  <label class="form-check-label" for="tetraneto">Tetraneto/a – 5ª geração</label>
                </div>
              </div>
              <div class="col-md-3 mb-2">
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="parentesco" id="pentaneto" value="pentaneto" formControlName="parentesco">
                  <label class="form-check-label" for="pentaneto">Pentaneto/a – 6ª geração</label>
                </div>
              </div>
              <div class="col-md-3 mb-2">
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="parentesco" id="hexaneto" value="hexaneto" formControlName="parentesco">
                  <label class="form-check-label" for="hexaneto">Hexaneto/a – 7ª geração</label>
                </div>
              </div>
              <div class="col-md-3 mb-2">
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="parentesco" id="heptaneto" value="heptaneto" formControlName="parentesco">
                  <label class="form-check-label" for="heptaneto">Heptaneto/a – 8ª geração</label>
                </div>
              </div>
            </div>
          </div>

          <!-- Visualização da Árvore Genealógica -->
          <div class="genealogical-tree">
            <div class="tree-container">
              <!-- Italiano/a -->
              <div class="tree-node root">
                <div class="node-content" [class.active]="selectedParentesco === 'filho'">
                  <div class="node-header">ITALIANO/A</div>
                  <div class="node-body" formGroupName="italiano">
                    <div class="node-info">
                      <input type="text" class="form-control" formControlName="nomeCompleto" placeholder="Nome completo">
                      <input type="date" class="form-control" formControlName="dataNascimento" placeholder="Data de nascimento">
                      <input type="text" class="form-control" formControlName="localNascimento" placeholder="Local de nascimento">
                      <div class="additional-info mt-3">
                        <div class="row">
                          <div class="col-md-6 mb-2">
                            <input type="text" class="form-control" formControlName="nomeConjuge" placeholder="Nome do cônjuge">
                          </div>
                          <div class="col-md-6 mb-2">
                            <input type="date" class="form-control" formControlName="dataCasamento" placeholder="Data de casamento">
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6 mb-2">
                            <input type="text" class="form-control" formControlName="localCasamento" placeholder="Local de casamento">
                          </div>
                          <div class="col-md-6 mb-2">
                            <input type="date" class="form-control" formControlName="dataObito" placeholder="Data do óbito">
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6 mb-2">
                            <input type="text" class="form-control" formControlName="localObito" placeholder="Local do óbito">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tree-branch"></div>
              </div>

              <!-- Filho/a do Italiano/a -->
              <div class="tree-node" *ngIf="selectedParentesco !== 'filho'">
                <div class="node-content" [class.active]="selectedParentesco === 'neto'">
                  <div class="node-header">FILHO/A DO/A ITALIANO/A</div>
                  <div class="node-body" formGroupName="filhoItaliano">
                    <div class="node-info">
                      <input type="text" class="form-control" formControlName="nomeCompleto" placeholder="Nome completo">
                      <input type="date" class="form-control" formControlName="dataNascimento" placeholder="Data de nascimento">
                      <input type="text" class="form-control" formControlName="localNascimento" placeholder="Local de nascimento">
                      <div class="additional-info mt-3">
                        <div class="row">
                          <div class="col-md-6 mb-2">
                            <input type="text" class="form-control" formControlName="nomeConjuge" placeholder="Nome do cônjuge">
                          </div>
                          <div class="col-md-6 mb-2">
                            <input type="date" class="form-control" formControlName="dataCasamento" placeholder="Data de casamento">
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6 mb-2">
                            <input type="text" class="form-control" formControlName="localCasamento" placeholder="Local de casamento">
                          </div>
                          <div class="col-md-6 mb-2">
                            <input type="date" class="form-control" formControlName="dataObito" placeholder="Data do óbito">
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6 mb-2">
                            <input type="text" class="form-control" formControlName="localObito" placeholder="Local do óbito">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tree-branch"></div>
              </div>

              <!-- Neto/a do Italiano/a -->
              <div class="tree-node" *ngIf="selectedParentesco !== 'filho' && selectedParentesco !== 'neto'">
                <div class="node-content" [class.active]="selectedParentesco === 'bisneto'">
                  <div class="node-header">NETO/A DO/A ITALIANO/A</div>
                  <div class="node-body" formGroupName="netoItaliano">
                    <div class="node-info">
                      <input type="text" class="form-control" formControlName="nomeCompleto" placeholder="Nome completo">
                      <input type="date" class="form-control" formControlName="dataNascimento" placeholder="Data de nascimento">
                      <input type="text" class="form-control" formControlName="localNascimento" placeholder="Local de nascimento">
                      <div class="additional-info mt-3">
                        <div class="row">
                          <div class="col-md-6 mb-2">
                            <input type="text" class="form-control" formControlName="nomeConjuge" placeholder="Nome do cônjuge">
                          </div>
                          <div class="col-md-6 mb-2">
                            <input type="date" class="form-control" formControlName="dataCasamento" placeholder="Data de casamento">
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6 mb-2">
                            <input type="text" class="form-control" formControlName="localCasamento" placeholder="Local de casamento">
                          </div>
                          <div class="col-md-6 mb-2">
                            <input type="date" class="form-control" formControlName="dataObito" placeholder="Data do óbito">
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6 mb-2">
                            <input type="text" class="form-control" formControlName="localObito" placeholder="Local do óbito">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tree-branch"></div>
              </div>

              <!-- Bisneto/a do Italiano/a -->
              <div class="tree-node" *ngIf="selectedParentesco !== 'filho' && selectedParentesco !== 'neto' && selectedParentesco !== 'bisneto'">
                <div class="node-content" [class.active]="selectedParentesco === 'trineto'">
                  <div class="node-header">BISNETO/A DO/A ITALIANO/A</div>
                  <div class="node-body" formGroupName="bisnetoItaliano">
                    <div class="node-info">
                      <input type="text" class="form-control" formControlName="nomeCompleto" placeholder="Nome completo">
                      <input type="date" class="form-control" formControlName="dataNascimento" placeholder="Data de nascimento">
                      <input type="text" class="form-control" formControlName="localNascimento" placeholder="Local de nascimento">
                      <div class="additional-info mt-3">
                        <div class="row">
                          <div class="col-md-6 mb-2">
                            <input type="text" class="form-control" formControlName="nomeConjuge" placeholder="Nome do cônjuge">
                          </div>
                          <div class="col-md-6 mb-2">
                            <input type="date" class="form-control" formControlName="dataCasamento" placeholder="Data de casamento">
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6 mb-2">
                            <input type="text" class="form-control" formControlName="localCasamento" placeholder="Local de casamento">
                          </div>
                          <div class="col-md-6 mb-2">
                            <input type="date" class="form-control" formControlName="dataObito" placeholder="Data do óbito">
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6 mb-2">
                            <input type="text" class="form-control" formControlName="localObito" placeholder="Local do óbito">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tree-branch"></div>
              </div>

              <!-- Trineto/a do Italiano/a -->
              <div class="tree-node" *ngIf="selectedParentesco !== 'filho' && selectedParentesco !== 'neto' && selectedParentesco !== 'bisneto' && selectedParentesco !== 'trineto'">
                <div class="node-content" [class.active]="selectedParentesco === 'tetraneto'">
                  <div class="node-header">TRINETO/A DO/A ITALIANO/A</div>
                  <div class="node-body" formGroupName="trinetoItaliano">
                    <div class="node-info">
                      <input type="text" class="form-control" formControlName="nomeCompleto" placeholder="Nome completo">
                      <input type="date" class="form-control" formControlName="dataNascimento" placeholder="Data de nascimento">
                      <input type="text" class="form-control" formControlName="localNascimento" placeholder="Local de nascimento">
                      <div class="additional-info mt-3">
                        <div class="row">
                          <div class="col-md-6 mb-2">
                            <input type="text" class="form-control" formControlName="nomeConjuge" placeholder="Nome do cônjuge">
                          </div>
                          <div class="col-md-6 mb-2">
                            <input type="date" class="form-control" formControlName="dataCasamento" placeholder="Data de casamento">
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6 mb-2">
                            <input type="text" class="form-control" formControlName="localCasamento" placeholder="Local de casamento">
                          </div>
                          <div class="col-md-6 mb-2">
                            <input type="date" class="form-control" formControlName="dataObito" placeholder="Data do óbito">
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6 mb-2">
                            <input type="text" class="form-control" formControlName="localObito" placeholder="Local do óbito">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tree-branch"></div>
              </div>

              <!-- Tetraneto/a do Italiano/a -->
              <div class="tree-node" *ngIf="selectedParentesco !== 'filho' && selectedParentesco !== 'neto' && selectedParentesco !== 'bisneto' && selectedParentesco !== 'trineto' && selectedParentesco !== 'tetraneto'">
                <div class="node-content" [class.active]="selectedParentesco === 'pentaneto'">
                  <div class="node-header">TETRANETO/A DO/A ITALIANO/A</div>
                  <div class="node-body" formGroupName="tetranetoItaliano">
                    <div class="node-info">
                      <input type="text" class="form-control" formControlName="nomeCompleto" placeholder="Nome completo">
                      <input type="date" class="form-control" formControlName="dataNascimento" placeholder="Data de nascimento">
                      <input type="text" class="form-control" formControlName="localNascimento" placeholder="Local de nascimento">
                      <div class="additional-info mt-3">
                        <div class="row">
                          <div class="col-md-6 mb-2">
                            <input type="text" class="form-control" formControlName="nomeConjuge" placeholder="Nome do cônjuge">
                          </div>
                          <div class="col-md-6 mb-2">
                            <input type="date" class="form-control" formControlName="dataCasamento" placeholder="Data de casamento">
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6 mb-2">
                            <input type="text" class="form-control" formControlName="localCasamento" placeholder="Local de casamento">
                          </div>
                          <div class="col-md-6 mb-2">
                            <input type="date" class="form-control" formControlName="dataObito" placeholder="Data do óbito">
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6 mb-2">
                            <input type="text" class="form-control" formControlName="localObito" placeholder="Local do óbito">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tree-branch"></div>
              </div>

              <!-- Pentaneto/a do Italiano/a -->
              <div class="tree-node" *ngIf="selectedParentesco !== 'filho' && selectedParentesco !== 'neto' && selectedParentesco !== 'bisneto' && selectedParentesco !== 'trineto' && selectedParentesco !== 'tetraneto' && selectedParentesco !== 'pentaneto'">
                <div class="node-content" [class.active]="selectedParentesco === 'hexaneto'">
                  <div class="node-header">PENTANETO/A DO/A ITALIANO/A</div>
                  <div class="node-body" formGroupName="pentanetoItaliano">
                    <div class="node-info">
                      <input type="text" class="form-control" formControlName="NOME" placeholder="Nome completo">
                      <input type="date" class="form-control" formControlName="dataNascimento" placeholder="Data de nascimento">
                      <input type="text" class="form-control" formControlName="localNascimento" placeholder="Local de nascimento">
                      <div class="additional-info mt-3">
                        <div class="row">
                          <div class="col-md-6 mb-2">
                            <input type="text" class="form-control" formControlName="nomeConjuge" placeholder="Nome do cônjuge">
                          </div>
                          <div class="col-md-6 mb-2">
                            <input type="date" class="form-control" formControlName="dataCasamento" placeholder="Data de casamento">
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6 mb-2">
                            <input type="text" class="form-control" formControlName="localCasamento" placeholder="Local de casamento">
                          </div>
                          <div class="col-md-6 mb-2">
                            <input type="date" class="form-control" formControlName="dataObito" placeholder="Data do óbito">
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6 mb-2">
                            <input type="text" class="form-control" formControlName="localObito" placeholder="Local do óbito">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tree-branch"></div>
              </div>

              <!-- Hexaneto/a do Italiano/a -->
              <div class="tree-node" *ngIf="selectedParentesco !== 'filho' && selectedParentesco !== 'neto' && selectedParentesco !== 'bisneto' && selectedParentesco !== 'trineto' && selectedParentesco !== 'tetraneto' && selectedParentesco !== 'pentaneto' && selectedParentesco !== 'hexaneto'">
                <div class="node-content" [class.active]="selectedParentesco === 'heptaneto'">
                  <div class="node-header">HEXANETO/A DO/A ITALIANO/A</div>
                  <div class="node-body" formGroupName="hexanetoItaliano">
                    <div class="node-info">
                      <input type="text" class="form-control" formControlName="nomeCompleto" placeholder="Nome completo">
                      <input type="date" class="form-control" formControlName="dataNascimento" placeholder="Data de nascimento">
                      <input type="text" class="form-control" formControlName="localNascimento" placeholder="Local de nascimento">
                      <div class="additional-info mt-3">
                        <div class="row">
                          <div class="col-md-6 mb-2">
                            <input type="text" class="form-control" formControlName="nomeConjuge" placeholder="Nome do cônjuge">
                          </div>
                          <div class="col-md-6 mb-2">
                            <input type="date" class="form-control" formControlName="dataCasamento" placeholder="Data de casamento">
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6 mb-2">
                            <input type="text" class="form-control" formControlName="localCasamento" placeholder="Local de casamento">
                          </div>
                          <div class="col-md-6 mb-2">
                            <input type="date" class="form-control" formControlName="dataObito" placeholder="Data do óbito">
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6 mb-2">
                            <input type="text" class="form-control" formControlName="localObito" placeholder="Local do óbito">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tree-branch"></div>
              </div>

              <!-- Cliente -->
              <div class="tree-node">
                <div class="node-content" [class.active]="true">
                  <div class="node-header">VOCÊ</div>
                  <div class="node-body" formGroupName="cliente">
                    <div class="node-info">
                      <input type="text" class="form-control" formControlName="nomeCompleto" placeholder="Nome completo">
                      <input type="date" class="form-control" formControlName="dataNascimento" placeholder="Data de nascimento">
                      <input type="text" class="form-control" formControlName="localNascimento" placeholder="Local de nascimento">
                      <div class="additional-info mt-3">
                        <div class="row">
                          <div class="col-md-6 mb-2">
                            <input type="text" class="form-control" formControlName="nomeConjuge" placeholder="Nome do cônjuge">
                          </div>
                          <div class="col-md-6 mb-2">
                            <input type="date" class="form-control" formControlName="dataCasamento" placeholder="Data de casamento">
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6 mb-2">
                            <input type="text" class="form-control" formControlName="localCasamento" placeholder="Local de casamento">
                          </div>
                          <div class="col-md-6 mb-2">
                            <textarea class="form-control" formControlName="filhos" rows="2" placeholder="Nomes e idades dos filhos, se tiver"></textarea>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6 mb-2">
                            <textarea class="form-control" formControlName="netos" rows="2" placeholder="Nomes e idades dos netos, se tiver"></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Agendamento no Consulado -->
      <div class="card mb-4" *ngIf="clienteForm.get('tipoDemanda')?.value === 'jure_sanguinis'">
        <div class="card-header">
          <h3>Agendamento no Consulado</h3>
        </div>
        <div class="card-body">
          <div class="mb-3">
            <label class="form-label">Você possui agendamento ou prova de agendamento em algum Consulado italiano?</label>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="temAgendamento" id="temAgendamentoSim" value="true" formControlName="temAgendamento">
              <label class="form-check-label" for="temAgendamentoSim">SIM</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="temAgendamento" id="temAgendamentoNao" value="false" formControlName="temAgendamento">
              <label class="form-check-label" for="temAgendamentoNao">NÃO</label>
            </div>
          </div>
          <div class="mb-3" *ngIf="clienteForm.get('temAgendamento')?.value === 'true'">
            <label for="nomeConsulado" class="form-label">Informar qual Consulado:</label>
            <input type="text" class="form-control" id="nomeConsulado" formControlName="nomeConsulado">
          </div>
        </div>
      </div>

      <!-- Upload de Documentos -->
      <div class="card mb-4" *ngIf="clienteForm.get('tipoDemanda')?.value === 'jure_sanguinis'">
        <div class="card-header">
          <h3>Documentos</h3>
        </div>
        <div class="card-body">
          <div class="mb-3">
            <label class="form-label">Faça upload dos documentos que entender necessários para a análise do seu caso:</label>
            <div class="document-upload-area">
              <div class="custom-file-upload">
                <input type="file" class="form-control" (change)="onFileSelected($event)" multiple accept=".pdf,.jpg,.jpeg,.png">
              </div>
              <div class="document-list mt-3">
                <div class="document-item d-flex justify-content-between align-items-center p-2 border rounded mb-2" *ngFor="let doc of documentos; let i = index">
                  <span class="text-truncate me-2" style="max-width: 80%;">{{doc.name}}</span>
                  <button type="button" class="btn btn-sm btn-danger" (click)="removeDocumento(i)">
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Botão de Envio -->
      <div class="text-center mb-5">
        <button type="submit" class="btn btn-primary btn-lg px-5" [disabled]="!clienteForm.valid || isLoading">
          <span *ngIf="!isLoading">
            <i class="fas fa-paper-plane me-2"></i>
            Enviar Cadastro
          </span>
          <span *ngIf="isLoading" class="d-flex align-items-center justify-content-center">
            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Enviando...
          </span>
        </button>
        <div class="mt-2" style="font-size: 0.95rem; color: #888;">
          <span><span style="color: red">*</span> Campos obrigatórios</span>
          <div *ngIf="faltandoCamposObrigatorios.length > 0" style="color: #c00; font-size: 0.97rem; margin-top: 0.5rem;">
            Preencha os campos obrigatórios: {{ faltandoCamposObrigatorios.join(', ') }}
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<!-- Modal de Sucesso -->
<ng-template #successModal>
  <div class="modal-header">
    <h4 class="modal-title">Cadastro Realizado com Sucesso!</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modalService.dismissAll()">
      <i class="fas fa-times"></i>
    </button>
  </div>
  <div class="modal-body text-center">
    <i class="fas fa-check-circle text-success" style="font-size: 4rem;"></i>
    <p class="mt-3">Sua demanda foi recebida. A partir de agora, você será atendido/a pessoalmente pelo Dr. Cristiano Girardello, entraremos em contato em breve.</p>
    <p class="mt-3">Seu acesso na plataforma é :</p>
    <p class="mt-3"><br>Login : {{email}}</p>
    <p class="mt-3">Senha : {{senha}} </p>
  <p class="mt-3"><br>Após acessar voce poderá alterar sua senha !</p> 
  <p class="mt-3">obs: senha é CPF - somente números</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="onSuccessOk()">OK</button>
  </div>
</ng-template>

<!-- Modal de Erro -->
<ng-template #errorModal>
  <div class="modal-header">
    <h4 class="modal-title">Erro no Cadastro</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modalService.dismissAll()">
      <i class="fas fa-times"></i>
    </button>
  </div>
  <div class="modal-body text-center">
    <i class="fas fa-exclamation-circle text-danger" style="font-size: 4rem;"></i>
    <p class="mt-3">Ocorreu um erro ao realizar seu cadastro. Por favor, tente novamente mais tarde.</p>
    <p class="mt-3">{{errorMessage}}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Fechar</button>
  </div>
</ng-template>

